var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCandlestickBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 4.25,
    width: 3.5,
    height: 9.5,
    stroke: "#008FC7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 0.75,
    width: 1.5,
    height: 3,
    fill: "#008FC7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 14.25,
    width: 1.5,
    height: 3,
    fill: "#008FC7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.25,
    y: 5.75,
    width: 3.5,
    height: 6.5,
    stroke: "#008FC7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 2.25,
    width: 1.5,
    height: 3,
    fill: "#008FC7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 12.75,
    width: 1.5,
    height: 3,
    fill: "#008FC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandlestickBlue);
export default __webpack_public_path__ + "static/media/candlestick_blue.2c031beb.svg";
export { ForwardRef as ReactComponent };